import {Component, OnDestroy, OnInit} from '@angular/core';
import {GameSectionService} from '../../../services/games/game-section/game-section.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {ContentContextService} from '../../../services/content-context/content-context.service';
import {PlatformService} from '../../../services/platform/platform.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {MetaService} from '../../../services/meta/meta.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LangTgtService } from 'src/app/services/lang-tgt/lang-tgt.service';
import { Router } from '@angular/router';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {CommonModule} from '@angular/common';
import {CourseMapComponent} from '../../../components/games/courses/course-map/course-map.component';
import {ProgressBarLightComponent} from '../../../components/progress/progress-bar-light/progress-bar-light.component';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-games-sections',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    CourseMapComponent,
    ProgressBarLightComponent
  ],
  templateUrl: './games-sections.component.html',
  styleUrls: ['./games-sections.component.scss']
})
export class GamesSectionsComponent implements OnInit, OnDestroy {

  loading = true;
  data: any;
  user: User;

  constructor(
    public langSrcSrv: LangSrcService,
    public platformSrv: PlatformService,
    private gameSectionSrv: GameSectionService,
    private gameLevelSrv: GameLevelService,
    public deviceSrv: DeviceDetectorService,
    private metaSrv: MetaService,
    private translate: TranslateService,
    private authSrv: AuthService,
    public langTgtSrv: LangTgtService,
    private router: Router,
    private contentContextSrv: ContentContextService
  ) {
  }

  async ngOnInit() {
    this.translate.get(`Jouer maintenant`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.user = await this.authSrv.getUser();
    await this.initialize();
  }

  // Parcours affiché par levels (peu de contenu, pas de page sections) — piloté par langTgt.displayLevels
  displayLevelsMode = false;

  async initialize() {
    if (this.platformSrv.platform.getIsExam()) {
      this.data = await this.gameLevelSrv.findAll();
    } else if (this.langTgtSrv.current?.displayLevels) {
      this.data = await this.gameLevelSrv.findAll();
      this.displayLevelsMode = true;
    } else {
      this.data = await this.gameSectionSrv.findAll();
      if (this.data?.sections?.length) {
        this.contentContextSrv.set({
          type: 'sections',
          items: this.data.sections.map((s: any) => ({id: s.uniqid, name: s.translation})),
        });
      }
    }
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.contentContextSrv.clear();
  }

  trackById(index: number, item: any) { return item.id; }

  get courseMapMode(): 'sections' | 'levels' | 'exam' {
    if (this.platformSrv.platform.getIsExam()) return 'exam';
    if (this.displayLevelsMode) return 'levels';
    return 'sections';
  }

  async navigateToSection(item: any) {
    if (!item.unlocked) return;

    // Examen de fin de palier : pas de levels, on va sur l'écran d'accueil de l'examen
    if (item.isExam && !this.platformSrv.platform.getIsExam() && !this.displayLevelsMode) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'cefrl-exam', item.uniqid]);
      return;
    }

    if (this.platformSrv.platform.getIsExam()) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games', 'exam', item.uniqid]);
    } else if (this.displayLevelsMode) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games', item.sectionUniqid, item.uniqid]);
    } else {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games', item.uniqid]);
    }
  }
}
